import { useMutation, useQueryClient } from '@tanstack/react-query'
import { isLamenessVideoMockEnabled } from 'components/cattles/lamenessPage/shared/helper/lamenessVideoMock'
import { IUpdateLamenessScoreRequest } from 'models/ICattlesData'
import CattlesApiService from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export const useUpdateLamenessScore = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation({
		mutationFn: async (data: IUpdateLamenessScoreRequest) => {
			if (isLamenessVideoMockEnabled()) {
				await new Promise(resolve => setTimeout(resolve, 500))
				return {
					cow_id: data.cow_id,
					limpness: data.limpness_score,
					limpness_confirmation: null,
				}
			}

			return CattlesApiService.updateLamenessScore(data)
		},
		onSuccess: () => {
			if (!isLamenessVideoMockEnabled()) {
				queryClient.invalidateQueries({ queryKey: ['cowsList'] })
				queryClient.invalidateQueries({ queryKey: ['lameHeadsFilterSource'] })
			}
			dispatch(
				notifyUser({
					title: 'Балл хромоты изменён',
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Не удалось изменить балл хромоты. Попробуйте снова.',
					isError: true,
				}),
			)
		},
	})
}
